export const formatDate = (isoDate: string) => {
  const date = new Date(isoDate);
  if (!isoDate.length || date.toString() === "Invalid Date") {
    return null;
  }

  const day = new Date(date).toLocaleString("en-GB", { day: "2-digit" });
  const month = new Date(date).toLocaleString("en-GB", { month: "2-digit" });
  const year = new Date(date).toLocaleString("en-GB", { year: "numeric" });

  return `${day}/${month}/${year}`;
};

export const formatWeekday = (isoDate: string) => {
  const date = new Date(isoDate);
  if (!isoDate.length || date.toString() === "Invalid Date") {
    return null;
  }

  const weekday = new Date(date).toLocaleString("en-GB", {
    weekday: "long",
  });

  return `${weekday}`;
};

export const formatDateAndWeekday = (isoDate: string) => {
  const date = new Date(isoDate);

  return date.toLocaleDateString("en-GB", {
    weekday: "short",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
